import { theme } from "@pluxee-design-system/core";
const CHART_FONT_PROPS_MAP = {
    size: "fontSize",
    weight: "fontWeight",
    lineHeight: "lineHeight",
    family: "fontFamily",
};
const fontPropsToChartPropsMapper = (mapping) => (fontProps) => Object.keys(mapping).reduce((acc, current) => {
    const key = current;
    const fontProp = mapping[key];
    if (fontProp) {
        return Object.assign(Object.assign({}, acc), { [key]: fontProps[fontProp] });
    }
    return acc;
}, {});
export const mapToFontProps = fontPropsToChartPropsMapper(CHART_FONT_PROPS_MAP);
export const generateAxisTitle = (title) => title
    ? {
        display: true,
        text: title,
        font: Object.assign({}, mapToFontProps(Object.assign(Object.assign({}, theme.textStyles.body.mediumBold), { fontFamily: theme.fonts.core[1] }))),
        color: theme.colors.semantic.text.tertiary,
    }
    : {};
export const generateTicks = () => ({
    font: Object.assign({}, mapToFontProps(Object.assign(Object.assign({}, theme.textStyles.body.largeMedium), { fontFamily: theme.fonts.core[1] }))),
    colors: theme.colors.semantic.text.tertiary,
});
export const customTooltip = ({ chart, tooltip, tooltipEl: tooltipElement, dataLabelPrefix, dataLabelSuffix, }) => {
    const tooltipEl = tooltipElement;
    if (!tooltipEl) {
        return;
    }
    if (!tooltip.opacity) {
        tooltipEl.style.display = "none";
        return;
    }
    const tooltipModel = tooltip.dataPoints.slice(0, 1).shift();
    if (tooltipModel) {
        const value = tooltipModel.formattedValue;
        tooltipEl.innerHTML =
            // eslint-disable-next-line no-useless-concat
            `${dataLabelPrefix} ` + `${value}` + `${dataLabelSuffix}`;
    }
    // tooltip must be rendered on the DOM to get width and height but we don't want to see it at this stage
    tooltipEl.style.display = "block";
    tooltipEl.style.opacity = "1";
    tooltipEl.style.zIndex = "-1";
    const tooltipWidth = tooltipEl.offsetWidth;
    const tooltipHeight = tooltipEl.offsetHeight;
    // Get chart canvas position relative to the viewport
    const position = chart.canvas.getBoundingClientRect();
    const chartRightEdge = position.left + chart.width;
    const maxLeft = chartRightEdge - tooltipWidth;
    const calculatedLeft = position.left + window.scrollX + tooltip.caretX - tooltipWidth / 2;
    // Use the smaller of calculatedLeft and maxLeft
    const finalLeft = Math.min(calculatedLeft, maxLeft);
    // Ensure the tooltip does not overflow on the left side
    const safeLeft = Math.max(finalLeft, position.left);
    tooltipEl.style.left = `${safeLeft}px`;
    tooltipEl.style.top = `${position.top + window.scrollY + tooltip.caretY - (tooltipHeight + 24)}px`;
    // In case the tooltip is repositioned, set dynamically the relative position for the caret
    tooltipEl.style.setProperty("--tooltip-adjusted-left", `${calculatedLeft - safeLeft}px`);
    // Make the tooltip visible
    tooltipEl.style.zIndex = "0";
};
//# sourceMappingURL=helpers.js.map